// @ts-expect-error pure js
import { SignatureContratStatus } from "../../models/signatureElectronique";
import Tooltip from "../UI/Tooltip";
import SignatureStatusMark from "./SignatureStatusMark";
import Status from "../UI/Status";
import Text from "../UI/Text";
import styles from "./ContractStatusIndicator.module.css";
import { IconInfoCircle } from "@tabler/icons-react";
import type { Signataire } from "../../models/document";

interface ContractFile {
  signature_electronique_status?: string | number | null;
  signataires?: Signataire[];
}

interface ContractStatusIndicatorProps {
  file?: ContractFile | null;
}

export default function ContractStatusIndicator({
  file,
}: ContractStatusIndicatorProps) {
  if (!file) return null;

  switch (file.signature_electronique_status) {
    case SignatureContratStatus.Opened.status:
    case SignatureContratStatus.Open.status:
      return (
        <Status
          color="warning"
          text={
            <>
              Signature électronique en attente{" "}
              {file.signataires && file.signataires.length > 0 && (
                <Tooltip
                  content={file.signataires.map((signataire, i) => (
                    <Text color="white" key={i} className={styles.signataire}>
                      {signataire.prenom} {signataire.nom}{" "}
                      <SignatureStatusMark status={signataire.status} />
                    </Text>
                  ))}
                >
                  <IconInfoCircle size={16} />
                </Tooltip>
              )}
            </>
          }
        />
      );
    case SignatureContratStatus.Signed.status:
    case SignatureContratStatus.Closed.status:
    case SignatureContratStatus.Archived.status:
      return <Status color="success" text="Signé électroniquement" />;
    case SignatureContratStatus.Canceled.status:
      return <Status color="danger" text="Signature électronique annulée" />;
  }
}
